import { graphql } from 'react-relay/legacy.js';
export const sitemapRoot = graphql`
    query sitemapRootQuery(
        $vertical: VerticalType
        $filterType: FilterType
        $filterTypeValue: String
        $level: Int
        $pageNumber: Int
    ) {
        viewer {
            ...SitemapWrapper_viewer
            ...sitemapRoute_tabTitle @relay(mask: false)
        }
    }
`;
